// extracted by mini-css-extract-plugin
module.exports = {"root":"before-footer-text-module__root___2Niod"};